import { documentCategories } from './../../../constants/document-categories';
// src/app/demo/components/documents/create-document/create-document.component.ts
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Message, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { DocumentsService } from 'src/app/demo/service/documents.service';
import { showErrorToast } from 'src/app/demo/utilities/toast-utils';

@Component({
  selector: 'app-create-document',
  standalone: true,
  imports: [ButtonModule, CommonModule, FormsModule, RouterModule,DropdownModule, MessagesModule,CheckboxModule, ReactiveFormsModule, CardModule, InputTextModule],
  templateUrl: './create-document.component.html',
  providers: [MessagesModule, MessageService]
})
export class CreateDocumentComponent implements OnInit {
  documentForm!: FormGroup;
  messages: Message[] = [];
  categories: any[] = documentCategories;
  selectedCategory: string = '';
  choices: any = [];

  ngOnInit() {
    this.initializeDocumentForm();
  }

  initializeDocumentForm() {
    this.documentForm = this.fb.group({
      documentName: ['', [Validators.required]],
      documentDescription: ['', [Validators.required]],
      requiresExpiryDate: [false,[Validators.required]],
      requiresIdentifier: [false,[Validators.required]],
      documentCategory: ['',[Validators.required]]
    });
  }

  constructor(private router: Router, private fb: FormBuilder,private translateService: TranslateService,private messageService: MessageService, private documentService: DocumentsService) { }

  onDocumentSubmit() {
    const documentPayload = this.documentForm.value;
    this.documentService.createDocumentType(documentPayload).subscribe({
      next: value => {
        this.showSuccessToast("Document created successfully");
        setTimeout(() => {
          this.router.navigate(['/home/documents']);
        }, 2000);
      },
      error: err => {
        showErrorToast(this.translateService.instant(err.error.messageKey), this.messageService,this.translateService)
      }
    });
  }

  showSuccessToast(message: string) {
    this.messages = [{ severity: 'success', summary: 'Success', detail: message }];
    setTimeout(() => {
      this.messages = [];
    }, 1000);
  }

  showErrorToast(message: string) {
    this.messages = [{ severity: 'error', summary: 'Error', detail: message }];
    setTimeout(() => {
      this.messages = [];
    }, 1000);
  }
}